import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { BRAND } from "@/lib/constants";
import { trackView } from "@/lib/track";

export default function Enquire() {
  useEffect(() => {
    trackView("/enquire");
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#09090B] text-white font-body" data-testid="enquire-page">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-zinc-950/85 border-b border-zinc-800">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
          <Link to="/" data-testid="enquire-logo-link" className="flex items-center">
            <img src={BRAND.logo} alt="JE Training" className="h-14 w-auto object-contain" />
          </Link>
          <Link
            to="/"
            data-testid="enquire-back-link"
            className="inline-flex items-center gap-2 text-zinc-400 hover:text-white font-display text-xs font-bold uppercase tracking-[0.16em] transition-colors"
          >
            <ArrowLeft size={14} strokeWidth={2} /> Full Website
          </Link>
        </div>
      </header>

      <main className="-mt-px">
        <Contact />
      </main>

      <Footer />
    </div>
  );
}
